import React from 'react';

import Layout from './components/Layout';
import SecurityQuestions from './components/SecurityQuestions';

const SecurityQuestionContainer = () => {
    return (
        <Layout>
            <SecurityQuestions />
        </Layout>
    );
};

export default SecurityQuestionContainer;